'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory(require('./IDate'));
    }
    if (typeof define !== 'undefined' && define.amd) {
        define('IPeriod', ['IDate'], function (IDate) {
            return factory(IDate);
        });
    } else {
        root.IPeriod = factory(root.IDate);
    }
})(window || module || {}, function (IDate) {
    var IPeriod = function () {
        function IPeriod(start, end) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            _classCallCheck(this, IPeriod);

            var parsed = void 0;

            this.separator = options.separator || '-';
            this.dateFormat = options.dateFormat || 'dd.mm.yyyy';

            if (
            // when 2nd argument are not Date object
            // in case of _prepareValue in Base.Model
            (typeof end === 'undefined' ? 'undefined' : _typeof(end)) === 'object' && !(end instanceof IDate || end instanceof Date)) {
                end = undefined;
            }

            parsed = this.parse(start, end);

            this.attributes = {
                start: parsed.start,
                end: parsed.end
            };

            // начальная больше конечной - перевернем
            if (this.attributes.end.getTime() < this.attributes.start.getTime()) {
                this.reverse();
            }

            return this;
        }

        _createClass(IPeriod, [{
            key: 'parse',
            value: function parse(arg1, arg2) {
                var start = void 0,
                    end = void 0,
                    monthMask = /^([a-zа-яїієё]+)[\s.]+((19|20)[\d]{2}|[\d]{2})/i;

                // nothing passed = today period
                if (arg1 === undefined && arg2 === undefined) {
                    return {
                        start: new IDate('today'),
                        end: new IDate('today')
                    };
                }

                // one of arguments is invalid = period is invalid
                if (arg1 === false || arg1 === null || arg1 === '') {
                    start = null;
                }

                if (arg2 === false || arg2 === null || arg2 === '') {
                    end = null;
                }

                if (start === null || end === null) {
                    return {
                        start: new IDate('Invalid date'),
                        end: new IDate('Invalid date')
                    };
                }

                // native IPeriod
                if (arg1 instanceof IPeriod) {
                    return {
                        start: new IDate(arg1.get('start')),
                        end: new IDate(arg1.get('end'))
                    };
                }

                // (30) --> today-today+30 days
                if (typeof arg1 === 'number') {
                    start = new IDate('today');
                    return {
                        start: start,
                        end: start.getShifted({ days: arg1 })
                    };
                }

                // '01.01.2015-01.02.2015'
                // '01.01.2015-today
                // '01.01.2015
                //  jan 2015 - feb 2015 --> 01.01.2015-28.02.2015
                if (typeof arg1 === 'string' && arg2 === undefined) {
                    var dates = arg1.trim().split(this.separator);

                    start = dates[0].trim();
                    end = dates[1] && dates[1].trim() || 'today';

                    if (monthMask.test(start) && monthMask.test(end)) {
                        end = new IDate(end).getShifted({ months: 1 }).getShifted({ days: -1 });
                    }

                    return {
                        start: new IDate(start),
                        end: new IDate(end)
                    };
                }

                // ('01.01.2015', 30) --> ('01.01.2015', '01.01.2015' + 30 days)
                if (arg1 && typeof arg2 === 'number') {
                    start = new IDate(arg1);

                    return {
                        start: start,
                        end: start.getShifted({ days: arg2 })
                    };
                }

                if (typeof arg1 === 'string' && typeof arg2 === 'string') {
                    start = arg1.trim();
                    end = arg2.trim();

                    if (monthMask.test(start) && monthMask.test(end)) {
                        end = new IDate(end).getShifted({ months: 1 }).getShifted({ days: -1 });
                    }

                    return {
                        start: new IDate(start),
                        end: new IDate(end)
                    };
                }

                // other cases
                return {
                    start: new IDate(arg1),
                    end: new IDate(arg2)
                };
            }

            /**
             * Меняет местами дату начала и конца периода
             * @private
             * @return {object}
             */

        }, {
            key: 'reverse',
            value: function reverse() {
                var tmp = this.attributes.end;

                this.attributes.end = this.attributes.start;
                this.attributes.start = tmp;

                return this;
            }

            /**
             * Возвращает разницу дат в периоде в указанных едтиницах
             * @param {string} units
             * @return {object}
             */

        }, {
            key: 'getUnitDifference',
            value: function getUnitDifference() {
                var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'days';

                return this.attributes.end.getUnitDifference(this.attributes.start, units);
            }

            /**
             * @return {boolean}
             */

        }, {
            key: 'validate',
            value: function validate() {
                return this.attributes.start.validate() && this.attributes.end.validate();
            }

            /**
             *
             * @param {string} dateFormat
             * @param {string} separator
             * @return {string}
             */

        }, {
            key: 'toString',
            value: function toString() {
                var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dateFormat;
                var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.separator;

                return this.attributes.start.toString(dateFormat) + separator + this.attributes.end.toString(dateFormat);
            }

            /**
             * @description Добавляет к периоду указанное кол-во дней/месяцев.. = this + counts,
             *  counts =  {years, months, days, hours, minutes, seconds, ms} || date(int)
             * @param {object} counts
             * @return {IPeriod}
             */

        }, {
            key: 'getShifted',
            value: function getShifted(counts) {
                var period = new IPeriod(this);

                period.attributes.start = period.attributes.start.getShifted(counts);
                period.attributes.end = period.attributes.end.getShifted(counts);

                return period;
            }

            /**
             *
             * @param {string} period
             * @return {boolean|*|Boolean}
             */

        }, {
            key: 'is',
            value: function is(period) {
                var _period = new IPeriod(period);

                return this.validate() && _period.validate() && this.attributes.end.is(_period.attributes.end, 'dd.mm.yyyy') && this.attributes.start.is(_period.attributes.start, 'dd.mm.yyyy');
            }

            /**
             * @param {string} attribute
             * @return {number}
             */

        }, {
            key: 'get',
            value: function get(attribute) {
                return this.attributes[attribute];
            }

            /**
             * @param {string} attribute
             * @param {string|number} value
             */

        }, {
            key: 'set',
            value: function set(attribute, value) {
                this.attributes[attribute] = value;
            }

            /**
             * @description Количество дней в периоде
             * @param {object} options
             *  - isRounded - возвращать округлённое кол-во дней или нет
             * @return {Number}
             */

        }, {
            key: 'getDaysCount',
            value: function getDaysCount() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                return Math[options.isRounded ? 'round' : 'ceil']((this.attributes.end.getTime() - this.attributes.start.getTime()) / (1000 * 60 * 60 * 24));
            }

            /**
             *
             * @return {boolean}
             */

        }, {
            key: 'isMonthPeriod',
            value: function isMonthPeriod() {
                return this.attributes.start.get('date') === 1 && this.hasSameMonths() && this.hasSameYears() && this.getUnitDifference('days') === this.attributes.start.getDaysInMonth() - 1;
            }

            /**
             *
             * @return {boolean}
             */

        }, {
            key: 'hasSameDates',
            value: function hasSameDates() {
                return this.attributes.start.get('date') === this.attributes.end.get('date');
            }

            /**
             *
             * @return {boolean}
             */

        }, {
            key: 'hasSameMonths',
            value: function hasSameMonths() {
                return this.attributes.start.get('month') === this.attributes.end.get('month');
            }

            /**
             *
             * @return {boolean}
             */

        }, {
            key: 'hasSameYears',
            value: function hasSameYears() {
                return this.attributes.start.get('year') === this.attributes.end.get('year');
            }

            /**
             * период c начала текущего месяца по сегодня
             * если сегодняшняя дата меньше 10, захватываем и предыдущий месяц
             * @return {IPeriod}
             */

        }, {
            key: 'getPeriodFromMonthStartToToday',
            value: function getPeriodFromMonthStartToToday() {
                console.warn('IPeriod prototype.getPeriodFromMonthStartToToday() is deprecated. Use IDate with shifted date.');
                return this;
            }
        }, {
            key: 'getMonthPeriod',
            value: function getMonthPeriod() {
                console.warn('IPeriod prototype.getMonthPeriod() is deprecated.');
                return this.toString();
            }

            /**
             * @description Возвращает разницу дат в периоде, end - start,
             *  {years, months, days, hours, minutes, seconds, ms}
             * @return {*}
             */

        }, {
            key: 'getDifference',
            value: function getDifference() {
                console.warn('IPeriod prototype.getDifference() is deprecated. Use .getUnitDifference().');
                return this.attributes.end.getDifference(this.attributes.start);
            }

            /**
             *
             * @return {string}
             */

        }, {
            key: 'toHtml',
            value: function toHtml() {
                console.warn('IPeriod prototype.toHtml() is deprecated. Use .toString().');
                return this.toString.apply(this, arguments);
            }
        }]);

        return IPeriod;
    }();

    return IPeriod;
});